import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BNav from 'components/shared/auth/nav/b-nav';
import BLink from 'components/shared/auth/nav/b-link';

const Navbar = ({ totalUnread }) => (
  <BNav>
    <BLink
      name={'Bookings'}
      url="/client"
      linkGap="p-5"
      count={0} />
    <BLink
      name={'Messages'}
      url="/client/messages"
      linkGap="p-5"
      count={totalUnread} />
    <BLink
      name={'Passport'}
      url="/client/passport"
      linkGap="p-5"
      count={0} />
    <BLink
      name={'Account'}
      linkGap="p-5"
      url="/client/account" />
  </BNav>
);

Navbar.propTypes = {
  totalUnread: PropTypes.number
}

const mapStateToProps = ({ messages }) => ({
  totalUnread: messages.index.totalUnread || 0,
});

export default connect(mapStateToProps)(Navbar);
